import React, { useState, useCallback, useEffect, useRef } from 'react'
import { useOnSelectionChange } from '@xyflow/react';
import { Tooltip } from '@mui/material';
import Iconify from '../../common/iconify/Iconify';
import { ICONIFY } from '../../../Constants/iconify';
import { NODE_TYPES } from '../constant';

export default function Toolbar() {

    const [open, setOpen] = useState(false)
    const flowContainer = useRef()

    const onChange = useCallback(({ nodes, edges }) => {
        if (nodes?.length >= 1) setOpen(true)
        else setOpen(false)
    }, []);

    useOnSelectionChange({
        onChange,
    });

    const handleClose = () => setOpen(false)

    // onDrag handler
    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    useEffect(() => {
        flowContainer.current = document.querySelector('.content-main-with-menu')
    }, [])

    return (
        <div className='toolbar'>
            {Object.keys(NODE_TYPES).map(type => (
                <Tooltip key={type} title={NODE_TYPES[type]}>
                    <div className='toolbar-item' draggable onDragStart={(e) => onDragStart(e, NODE_TYPES[type])}>
                        <Iconify icon={ICONIFY[NODE_TYPES[type]]} />
                    </div>
                </Tooltip>
            ))}
        </div>
    )
}
